import { useState, useEffect } from "react";
import Hero from "./Hero/Hero";
import Gallery from "./Gallery/Gallery";
import Landing from "./Landing/Landing";
import CategoryTabs from "../../../CategoryTabs/CategoryTabs";
import Container from "Components/Container/Container";

import useFetch from "Hooks/useFetch";
import LoadingScreen from "Components/RequestHandler/LoadingScreen";
import { useParams } from "react-router-dom";
import IsError from "Components/RequestHandler/IsError";
const PastCourses = () => {
  const { slug } = useParams();

  const [data, setData] = useState();
  const [isLoading, setIsLoading] = useState(false);
  const [isError, setIsError] = useState(false);
  const { fetchData, error } = useFetch();

  const getData = async () => {
    setIsLoading(true);
    setIsError(false);

    try {
      const data = await fetchData(`academy-training-and-workShop/${slug}`);
      setData(data);
    } catch (error) {
      setIsError(true);
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    getData();
  }, [slug]);

  if (isLoading) return <LoadingScreen />;
  if (error || isError) return <IsError />;
  if (data) {
    return (
      <main className="scroll-section-special">
        <Hero course_title={data?.course_title} />
        <Container>
          <div className="grid grid-cols-1 lg:grid-cols-4 gap-x-10 pb-primary lg:-mt-[20vh]">
            <div className="col-span-1">
              <div className="sticky top-[10vh]">
                <CategoryTabs
                  selectedCategory="trainings-and-workshops"
                  isInner={true}
                />
              </div>
            </div>
            <div className="col-span-3">
              <Gallery data={data} />
              <Landing data={data} />
            </div>
          </div>
        </Container>
      </main>
    );
  }
};

export default PastCourses;
